document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.getElementById("see-size-video");
  const modal = document.getElementById("roami-video-modal");
  const form = document.getElementById("roami-fit-form");
  const closeBtn = document.getElementById("roami-close");
  const cancelBtn = document.getElementById("roami-cancel");

  const videoContainer = document.getElementById("roami-video-container");
  const measurementContainer = document.getElementById("roami-measurement-result");

  if (!openBtn || !modal || !form || !videoContainer || !measurementContainer) return;

  openBtn.addEventListener("click", function () {
    modal.showModal();
  });

  function clearAndCloseModal() {
    modal.close();
    videoContainer.innerHTML = "";
    measurementContainer.innerHTML = "";
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", clearAndCloseModal);
  }

  if (cancelBtn) {
    cancelBtn.addEventListener("click", clearAndCloseModal);
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    const formData = new FormData(form);

    const user = {
      profile: MEASUREMENT_PROFILE,
      gender: formData.get("gender"),
      size_system: formData.get("size_system"),
      numeric_size: Number(formData.get("numeric_size")),
      height: Number(formData.get("height")),
      chest: Number(formData.get("chest"))
    };

    const HEIGHT_MAX = 198;
    const HEIGHT_MIN = 140;
    const US_SIZE_MAX = 34;
    const US_SIZE_MIN = 2;
    const UK_SIZE_MAX = 40;
    const UK_SIZE_MIN = 5;

    const UK_CIRRUS_LINK = "https://deltaroam.com/pages/size-guide-cirrus-jacket";
    const US_CIRRUS_LINK = "https://deltaroam.com/en-us/pages/size-guide-cirrus-jacket-us";
    const UK_BEAUMONT_LINK = "https://deltaroam.com/pages/size-guide-robes";
    const US_BEAUMONT_LINK = "https://deltaroam.com/en-us/pages/size-guide-robes-us";

    const sizeChartIndex = getJsonFromElement("roami-size-chart-recommendation-index", []);
    const videoIndex = getJsonFromElement("roami-video-index", []);

    const recommendedSize = findRecommendedSize(sizeChartIndex, user);

    let size_link = "";

    if (user.size_system === "UK" && user.profile === "beaumont") {
      size_link = UK_BEAUMONT_LINK;
    }

    if (user.size_system === "US" && user.profile === "beaumont") {
      size_link = US_BEAUMONT_LINK;
    }

    if (user.size_system === "UK" && user.profile === "cirrus") {
      size_link = UK_CIRRUS_LINK;
    }

    if (user.size_system === "US" && user.profile === "cirrus") {
      size_link = US_CIRRUS_LINK;
    }

    let invalid = false;

    if (user.height < HEIGHT_MIN || user.height > HEIGHT_MAX) {
      invalid = true;
    }

    if (!invalid) {
      if (
        user.size_system === "UK" &&
        (user.numeric_size < UK_SIZE_MIN || user.numeric_size > UK_SIZE_MAX)
      ) {
        invalid = true;
      }

      if (
        user.size_system === "US" &&
        (user.numeric_size < US_SIZE_MIN || user.numeric_size > US_SIZE_MAX)
      ) {
        invalid = true;
      }
    }

    if (invalid) {
      videoContainer.innerHTML = "";

      measurementContainer.innerHTML = `
        <h4 style="margin: 0 0 12px; font-size: 14px; color: #111;">
          recommended size:
          <span style="color: #e00; font-weight: 700;">${recommendedSize}</span>
        </h4>

        <p style="margin: 10px 0 10px 0; font-size: 12px; color: rgba(0,0,0,0.55);">
          Your exact height and size combination is not yet featured in our model videos.
          <br><br>
          The guide is a reference. The robe is designed with flexible layering space, so most customers fall comfortably within the recommended size.
          <br><br>
          Check out our
          <a href="${size_link}" target="_blank" style="color:#000; text-decoration: underline;">
            size chart for more details
          </a>.
        </p>
      `;

      return;
    }

    const bestMatches = findBestVideos(videoIndex, user);

    if (bestMatches.length) {
      renderVideos(bestMatches, size_link, recommendedSize, user);
    } else {
      videoContainer.innerHTML = "";
      measurementContainer.innerHTML = "<p>No suitable video found.</p>";
    }
  });
});

function getJsonFromElement(elementId, fallback) {
  const element = document.getElementById(elementId);

  if (!element || !element.textContent.trim()) {
    return fallback;
  }

  try {
    return JSON.parse(element.textContent);
  } catch (error) {
    console.error("Invalid JSON in element:", elementId, error);
    return fallback;
  }
}

function findBestVideos(videos, user) {
  const candidates = videos
    .filter(function (video) {
      return (
        video.profile === user.profile &&
        video.gender === user.gender
      );
    })
    .map(function (video) {
      return {
        ...video,
        height: Number(video.height),
        chest: Number(video.chest),
        us_size: Number(video.us_size),
        uk_size: Number(video.uk_size)
      };
    });

  if (!candidates.length) return [];

  const sizeKey = user.size_system === "US" ? "us_size" : "uk_size";

  const ranked = candidates.map(function (video) {
    return {
      video: video,
      score: getMatchScore(video, user, sizeKey)
    };
  });

  ranked.sort(function (a, b) {
    for (let i = 0; i < a.score.length; i++) {
      if (a.score[i] !== b.score[i]) {
        return a.score[i] - b.score[i];
      }
    }

    return 0;
  });

  const topMatch = ranked[0];

  if (!topMatch) return [];

  const maxVideosToRender = 2;

  const topMatchedVideos = ranked
    .filter(function (item) {
      return scoresMatchExactly(item.score, topMatch.score);
    })
    .slice(0, maxVideosToRender)
    .map(function (item) {
      return item.video;
    });

  return topMatchedVideos.length ? topMatchedVideos : [topMatch.video];
}

function getMatchScore(video, user, sizeKey) {
  const heightDiff = Math.abs(video.height - user.height);
  const chestDiff = Math.abs(video.chest - user.chest);
  const sizeDiff = Math.abs(video[sizeKey] - user.numeric_size);

 
  const HEIGHT_RANGE = 10; 
  const CHEST_RANGE = 10;
  const SIZE_RANGE = 2; 

  if (user.gender === "M") {
    const balancedScore =
      (heightDiff / HEIGHT_RANGE) * 0.5 +
      (chestDiff / CHEST_RANGE) * 0.5;

    return [
      balancedScore,
      heightDiff,
      chestDiff
    ];
  }

  if (user.gender === "F") {
    const balancedScore =
      (sizeDiff / SIZE_RANGE) * 0.5 +
      (heightDiff / HEIGHT_RANGE) * 0.5;

    return [
      balancedScore,
      sizeDiff,
      heightDiff
    ];
  }

  return [Infinity, Infinity, Infinity];
}

function scoresMatchExactly(score1, score2) {
  if (!score1 || !score2) return false;
  if (score1.length !== score2.length) return false;

  return score1.every(function (value, index) {
    return value === score2[index];
  });
}

function renderVideos(videos, size_link, recommendedSize, user) {
  const videoContainer = document.getElementById("roami-video-container");
  const measurementContainer = document.getElementById("roami-measurement-result");

  if (!videoContainer || !measurementContainer) return;

  const videoCount = videos.length;
  const showMultiple = videoCount > 1;

  videoContainer.innerHTML = `
    <style>
      .roami-video-grid {
        margin-top: 14px;
        width: 100%;
        display: grid;
        grid-template-columns: ${videoCount === 1 ? "minmax(0, 320px)" : `repeat(${videoCount}, minmax(0, 1fr))`};
        gap: 14px;
        align-items: start;
        justify-content: center;
      }

      .roami-video-card {
        width: 100%;
        min-width: 0;
        border-radius: 14px;
        overflow: hidden;
        background: #000;
        box-shadow: 0 4px 20px rgba(0,0,0,0.12);
      }

      .roami-video-card video {
        width: 100%;
        height: auto;
        display: block;
        object-fit: contain;
        max-height: ${showMultiple ? "70vh" : "520px"};
        background: #000;
      }

      .roami-result-box {
        margin-top: 16px;
        padding: 16px;
        border: 1px solid rgba(0,0,0,0.10);
        border-radius: 14px;
        background: #50574c;
        box-sizing: border-box;
        overflow: hidden;
      }

      .roami-result-title {
        margin: 0 0 12px;
        font-size: 14px;
        color: #f3ece0;
        text-align: center;
        letter-spacing: 4px;
        text-transform: uppercase;
      }

      .roami-result-title span {
        color: #ffffff;
        font-weight: 700;
      }

      .roami-result-copy {
        margin: 0 0 12px;
        font-size: 12px;
        color: #f3ece0;
        text-transform: lowercase;
        text-align: center;
      }

      .roami-measurement-grid {
        display: grid;
        grid-template-columns: ${videoCount === 1 ? "1fr" : `repeat(${videoCount}, minmax(0, 1fr))`};
        gap: 12px;
      }

      .roami-measurement-card {
        min-width: 0;
        box-sizing: border-box;
        padding: 12px;
        border: 1px solid rgba(0,0,0,0.08);
        border-radius: 12px;
        background: #f3ece0;
        overflow: hidden;
      }

      .roami-model-wearing {
        margin: 0 0 10px;
        font-size: 12px;
        color: rgba(0,0,0,0.55);
        text-transform: lowercase;
        text-align: center;
        line-height: 1.3;
      }

      .roami-model-wearing span {
        font-weight: bold;
        color: #50574c;
        text-transform: uppercase;
      }

      .roami-measurement-row {
        display: grid;
        width: 100%;
        border: 1px solid rgba(0,0,0,0.08);
        box-sizing: border-box;
        overflow: hidden;
      }

      .roami-measurement-row.male {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }

      .roami-measurement-row.female {
        grid-template-columns: repeat(3, minmax(0, 1fr));
      }

      .roami-measurement-cell {
        min-width: 0;
        box-sizing: border-box;
        padding: 8px 10px;
        background: #50574c;
        border-right: 1px solid rgba(0,0,0,0.18);
      }

      .roami-measurement-cell:last-child {
        border-right: none;
      }

      .roami-measurement-label {
        display: block;
        font-size: 11px;
        color: #f3ece0;
        text-transform: lowercase;
        margin-bottom: 2px;
        line-height: 1.25;
        word-break: break-word;
      }

      .roami-measurement-value {
        display: block;
        color: #f3ece0;
        font-size: 14px;
        line-height: 1.25;
        word-break: break-word;
      }

      @media screen and (max-width: 640px) {
        .roami-video-grid {
          grid-template-columns: repeat(${videoCount}, minmax(0, 1fr));
          gap: 8px;
        }

        .roami-video-card video {
          max-height: 420px !important;
        }

        .roami-result-box {
          padding: 12px;
          border-radius: 12px;
        }

        .roami-result-title {
          font-size: 12px;
          letter-spacing: 2.5px;
          margin-bottom: 10px;
        }

        .roami-result-copy {
          font-size: 11px;
          line-height: 1.35;
          margin-bottom: 10px;
        }

        .roami-measurement-grid {
          grid-template-columns: repeat(${videoCount}, minmax(0, 1fr));
          gap: 8px;
        }

        .roami-measurement-card {
          padding: 8px;
          border-radius: 10px;
        }

        .roami-model-wearing {
          font-size: 10px;
          margin-bottom: 7px;
        }

        .roami-measurement-cell {
          padding: 6px 4px;
        }

        .roami-measurement-label {
          font-size: 9px;
          line-height: 1.2;
          margin-bottom: 2px;
        }

        .roami-measurement-value {
          font-size: 12px;
          line-height: 1.2;
        }
      }

      @media screen and (max-width: 380px) {
        .roami-result-box {
          padding: 10px;
        }

        .roami-measurement-grid {
          gap: 6px;
        }

        .roami-measurement-card {
          padding: 6px;
        }

        .roami-model-wearing {
          font-size: 9px;
        }

        .roami-measurement-cell {
          padding: 5px 3px;
        }

        .roami-measurement-label {
          font-size: 8px;
        }

        .roami-measurement-value {
          font-size: 11px;
        }
      }
    </style>

    <div class="roami-video-grid">
      ${videos.map(function (video) {
        return `
          <div class="roami-video-card">
            <video
              controls
              autoplay
              playsinline
              muted
            >
              <source src="${video.url}" type="video/mp4">
            </video>
          </div>
        `;
      }).join("")}
    </div>
  `;

  measurementContainer.innerHTML = `
    <div class="roami-result-box">
      <h4 class="roami-result-title">
        recommended size:
        <span>${recommendedSize}</span>
      </h4>

      <p class="roami-result-copy">
        ${showMultiple
          ? `we found ${videoCount} videos with the same closest measurement match.`
          : "model wearing the closest match to your build."}
      </p>

      <div class="roami-measurement-grid">
        ${videos.map(function (video) {
          const measurementHtml = user.gender === "M"
            ? `
              <div class="roami-measurement-row male">
                <div class="roami-measurement-cell">
                  <span class="roami-measurement-label">height</span>
                  <strong class="roami-measurement-value">${video.height} cm</strong>
                </div>

                <div class="roami-measurement-cell">
                  <span class="roami-measurement-label">chest</span>
                  <strong class="roami-measurement-value">${video.chest}</strong>
                </div>
              </div>
            `
            : `
              <div class="roami-measurement-row female">
                <div class="roami-measurement-cell">
                  <span class="roami-measurement-label">height</span>
                  <strong class="roami-measurement-value">${video.height} cm</strong>
                </div>

                <div class="roami-measurement-cell">
                  <span class="roami-measurement-label">uk size</span>
                  <strong class="roami-measurement-value">${video.uk_size}</strong>
                </div>

                <div class="roami-measurement-cell">
                  <span class="roami-measurement-label">us size</span>
                  <strong class="roami-measurement-value">${video.us_size}</strong>
                </div>
              </div>
            `;

          return `
            <div class="roami-measurement-card">
              <p class="roami-model-wearing">
                model wearing
                <span>${video.size_worn}</span>
              </p>

              ${measurementHtml}
            </div>
          `;
        }).join("")}
      </div>
    </div>

    <p style="margin: 10px 0 10px 0; font-size: 12px; color: rgba(0,0,0,0.55); text-align: center;">
      See more details on our
      <a href="${size_link}" target="_blank" style="color:#000; text-decoration: underline;">
        Size Guide
      </a>
      page.
    </p>
  `;
}

function findRecommendedSize(sizeCharts, user) {
  const chart = sizeCharts.find(function (item) {
    return item.profile === user.profile;
  });

  if (!chart) return "N/A";

  const rows = chart.size_chart;

  if (user.height < 140 || user.height > 220) return "N/A";

  let closestHeightRow = null;
  let minHeightDiff = Infinity;

  rows.forEach(function (row) {
    const height = Number(row.height_cm);
    const diff = Math.abs(height - user.height);

    if (diff < minHeightDiff) {
      minHeightDiff = diff;
      closestHeightRow = row;
    }
  });

  if (!closestHeightRow) return "N/A";

  const sizes = closestHeightRow.sizes;

  if (user.gender === "F") {
    const sizeKey = user.size_system === "UK" ? "uk_size" : "us_size";

    const availableSizes = sizes.map(function (size) {
      return Number(size[sizeKey]);
    });

    const minSize = Math.min(...availableSizes);
    const maxSize = Math.max(...availableSizes);

    if (user.numeric_size < minSize || user.numeric_size > maxSize) {
      return "N/A";
    }

    let closest = null;
    let minDiff = Infinity;

    sizes.forEach(function (size) {
      const currentSize = Number(size[sizeKey]);
      const diff = Math.abs(currentSize - user.numeric_size);

      if (diff < minDiff) {
        minDiff = diff;
        closest = size;
      }
    });

    let recommended = closest ? closest.recommended_size : "N/A";

    if (recommended === null) {
      recommended = "N/A";
    }

    return recommended;
  }

  if (user.gender === "M") {
    const availableChest = sizes.map(function (size) {
      return Number(size.chest);
    });

    const minChest = Math.min(...availableChest);
    const maxChest = Math.max(...availableChest);

    if (user.chest < minChest || user.chest > maxChest) {
      return "N/A";
    }

    let closest = null;
    let minDiff = Infinity;

    sizes.forEach(function (size) {
      const chest = Number(size.chest);
      const diff = Math.abs(chest - user.chest);

      if (diff < minDiff) {
        minDiff = diff;
        closest = size;
      }
    });

    let recommended = closest ? closest.recommended_size : "N/A";

    if (recommended === null) {
      recommended = "N/A";
    }

    return recommended;
  }

  return "N/A";
}